import PropTypes from 'prop-types';
import React from 'react';
import { Card } from '@amzn/stencil-react-components/card';
import { Col, Row } from '@amzn/stencil-react-components/layout';
import { Radio } from '@amzn/stencil-react-components/radio';
import { Text } from '@amzn/stencil-react-components/text';
import { css } from '@emotion/react';

export const CardWithRadio = ({
  width,
  height,
  isChecked,
  label,
  description,
  radioName,
  radioValue,
  style,
  isDisabled,
  onChange,
}) => {
  return (
    <>
      <Card
        css={
          isChecked &&
          css`
            background: #23756b;
            color: white;
            border-radius: 0
          `
        }
        width={width}
        height={height}
        style={style}
      >
        <Col gridGap={32}>
          <Col display="flex" style={{ flexDirection: 'row' }}>
            <Row width={'85%'}>
              <Text fontSize="T300">{label}</Text>
            </Row>
            <Row width={'15%'}>
              <Radio
                name={radioName}
                data-testid="card-radio"
                value={radioValue}
                checked={isChecked}
                disabled={isDisabled}
                onChange={onChange}
              />
            </Row>
          </Col>
          <Text
            css={
              isChecked &&
              css`
                color: white;
              `
            }
            color="neutral70"
          >
            {description}
          </Text>
        </Col>
      </Card>
    </>
  );
};

CardWithRadio.defaultProps = {
  width: '25%',
  isChecked: false,
  onChange: () => {},
  style: {},
  isDisabled: false,
};

CardWithRadio.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  radioName: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  radioValue: PropTypes.string,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
};
